<template>
  <div class="p-custom-input-container">
    <p-input-text
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
      :type="type"
      :step="step"
      :min="min"
      :max="max"
    />

    <!-- 		<p-input-number
			v-else-if='type === "number"'
			:value='value'
			:placeholder='placeholder'
			:disabled='disabled'
			@input='onInput'
			:type='numberMode'

		/> -->
  </div>
</template>

<script>
export default {
  name: "CustomPInput",

  props: {
    value: {
      type: null /* null - любой тип */,
      required: true,
    },

    placeholder: {
      type: String,
      default: "Введите значение",
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: null,
    },

    step: {
      type: String,
      default: "any",
    },

    min: {
      type: String,
      default: "any",
    },

    max: {
      type: String,
      default: "any",
    },
  },

  methods: {
    onInput(value) {
      if (value === "") {
        value = null;
      }

      // if (this.type === 'number' && this.value === ',') {

      // }

      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/constants.scss";

.p-inputtext,
.p-inputnumber {
  width: 100%;
}

.p-inputtext::placeholder {
  color: $placeholder-color;
}
</style>
